import { Request } from './Request';

export interface IGetFieldConceptIndexingStatusParams {
  readonly field_concept_uri: string;
}

export type FieldConceptIndexingStatusCode = 'INDEXING_STATUS_UNSPECIFIED' | 'INDEXING_IN_PROGRESS' | 'INDEXING_PENDING' | 'INDEXING_FAILED_RETRY_PENDING' | 'INDEXING_FAILED' | 'INDEXING_COMPLETE' | 'INDEXING_UNSUPPORTED';

export interface IGetFieldConceptIndexingStatusResult {
  readonly fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
  readonly fieldConceptIndexingErrorCode: string; // Values don't get communicated to user, so this doesn't need to be typed.
}

export class GetFieldConceptIndexingStatusRequest extends Request<IGetFieldConceptIndexingStatusParams, IGetFieldConceptIndexingStatusResult> {
  constructor(params: IGetFieldConceptIndexingStatusParams) {
    super('getIndexingStatus', params);
  }
}
